import React from "react";
import { array } from "prop-types";

import MobileLogo from "../../atoms/MobileLogo";
import ProfileHeadline from "../../atoms/ProfileHeadline";

import "./newsletter-subscriptions.m.css";

const UserNewsletterSubscriptions = ({ list }) => {
  return (
    <div styleName="container">
      <ProfileHeadline title="Newsletters" />

      <div styleName="newsletter-wrapper">
        {list &&
          list.map((item, index) => (
            <div key={index} styleName="wrapper">
              <div styleName="content">
                <span styleName="section-name">{item.name}</span>
                <span styleName="type">{item.type}</span>
              </div>
              <div styleName="subscribed">SUBSCRIBED</div>
            </div>
          ))}

        <div styleName="sign-up-more">
          <div styleName="know-more-content">
            <span styleName="sign-up-more-title">Sign up for more Newsletters</span>
            <button styleName="know-more">FIND OUT MORE</button>
          </div>

          <MobileLogo />
        </div>
      </div>
    </div>
  );
};

UserNewsletterSubscriptions.propTypes = {
  list: array
};

export default UserNewsletterSubscriptions;
